<div class="header">
  <h3>{{ 'sideNav.webhookEventsLogs' | translate }}</h3>
</div>

<!-- Table Component -->
<app-table></app-table>
